/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const LoaderContext = createContext();

export function LoaderProvider({ children }) {
    const [loading, setLoading] = useState(false);
    const value = useMemo(() => ({ loading, setLoading }), [loading]);
    return (
        <LoaderContext.Provider value={value}>
            {children}
        </LoaderContext.Provider>
    );
}

LoaderProvider.propTypes = {
    children: PropTypes.node,
};

export function useLoader() {
    return useContext(LoaderContext);
}
